import React, { FC } from 'react'
import Hero from '../components/HeaderSection'
import TopTiles from '../components/TopTiles'
import ArtAdvisoryCallout from '../components/ArtAdvisory/ArtAdvisoryCallout'
import ShopByPrice from '../components/ShopByPrice'
import ShopByCategory from '../components/ShopByCategory'
import FeaturedCollections from '../components/FeaturedCollections'
import ValueProps from '../components/ValueProps/ValueProps'
import styles from '../components/Homepage.module.scss'
import FeaturedStories from '../components/FeaturedStories'
import ProductCarousels from '../components/ProductCarousels'

const HomepageLayout: FC = () => (
  <div className={styles.homepage}>
    <div className={styles.heroTilesSection}>
      <Hero />
      <TopTiles />
    </div>
    <ShopByCategory />
    <FeaturedCollections />
    <ValueProps />
    <ProductCarousels />
    <ShopByPrice />
    <FeaturedStories />
    <ArtAdvisoryCallout />
  </div>
)

export default HomepageLayout
